import { Navigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { AuthLoadingFallback } from '@/components/auth/ProtectedRoute';
import { packageCodeToFeId, preAssessmentPathForFeId } from '@/lib/certificationType';

const PACKAGE_ORDER = ['HALAL', 'SLHS', 'HACCP'];

/** Legacy `/pre-assessment` → first entitled package’s scoped path, else dashboard. */
export function PreAssessmentRedirect() {
  const { user, authHydrated } = useApp();
  if (!authHydrated) return <AuthLoadingFallback />;
  const active = new Set((user.active_packages || []).map((c) => String(c).toUpperCase()));
  for (const code of PACKAGE_ORDER) {
    if (active.has(code)) {
      const fe = packageCodeToFeId(code);
      if (fe) return <Navigate to={preAssessmentPathForFeId(fe)} replace />;
    }
  }
  return <Navigate to="/dashboard" replace />;
}
